import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

export default function TestimonialCards({ blok }) {

  return (
    <div {...storyblokEditable(blok)}>
      {blok?.blocks.map((block) => (
        <StoryblokComponent blok={block} key={block._uid} />
      ))}
    </div>
  );
}
